import { atom } from 'jotai'
import { SetStateAction } from 'react'

type IFetchState = number

const defaultState: IFetchState = 0

// base atom with initial value
const _fetchIsLoadingAtom = atom<IFetchState>(defaultState)
// read-write derived atom
export const fetchIsLoadingAtom = atom(
	// getter
	(get) => get(_fetchIsLoadingAtom),

	// setter with custom logic
	(get, set, value: SetStateAction<IFetchState>) => {
		const currentValue = get(_fetchIsLoadingAtom)
		const nextValue =
			typeof value === 'function' ? value(currentValue) : value
		//console.log('fetchIsLoadingAtom: setter:: ', {currentValue, nextValue})
		// setter error handler
		if (+nextValue >= 0) {
			return set(_fetchIsLoadingAtom, nextValue)
		}
		throw new Error('fetchIsLoadingAtom: setter:: Incorrect value set')
	}
)

// smth like 'action-creators' from redux
export const turnOnLoader = (currVal: IFetchState) => currVal + 1
export const turnOffLoader = (currVal: IFetchState) => currVal - 1